import React, { useState } from 'react';
import Leads from './Leads';
import Deals from './Deals';
import './crm.scss';

const TABS = [
  { key: 'leads', label: 'Leads', icon: '👤' },
  { key: 'deals', label: 'Deals', icon: '🤝' }
];

function CRM() {
  const [activeTab, setActiveTab] = useState('leads');

  return (
    <div className="crm-container p-3 min-vh-100 bg-secondary bg-opacity-10">
      <div className="crm-header p-3 bg-white rounded-3 shadow-2 mb-3">
        <h2 className="m-0 text-black fw-bold fs-4">CRM</h2>
      </div>

      <div className="crm-tab-content bg-white rounded-3 shadow-2 overflow-hidden">
        <ul className="nav nav-tabs px-3 pt-3 border-bottom gap-2">
          {TABS.map((tab) => (
            <li className="nav-item" key={tab.key}>
              <button
                type="button"
                className={`nav-link fw-bold border-0 border-bottom border-3 rounded-2 px-3 py-2 d-flex align-items-center gap-2 ${
                  activeTab === tab.key
                    ? 'active text-primary border-primary bg-primary bg-opacity-10'
                    : 'text-black text-opacity-50 link-opacity-100-hover'
                }`}
                onClick={() => setActiveTab(tab.key)}
              >
                <span className="fs-6">{tab.icon}</span>
                <span>{tab.label}</span>
              </button>
            </li>
          ))}
        </ul>

        <div className="p-3">
          {activeTab === 'leads' && <Leads />}
          {activeTab === 'deals' && <Deals />}
        </div>
      </div>
    </div>
  );
}

export default CRM;